<ng-container *ngIf="!isLoggedIn()">{{ redirect() }}</ng-container>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item">
                <a class="nav-link" routerLink="/admin">Survey details</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="/addAdmin">Add Admin</a>
            </li>
        </ul>
    </div>
</nav>
<app-list-admins></app-list-admins>

<router-outlet></router-outlet>

